import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnrollmentReportStudent } from 'src/app/component/child-reports/enrollment-report/model/enrollment-report-result.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { StudentSchoolEnrollmentService } from '../../../service/student-school-enrollment.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'delete-group-child-enrollment-modal',
    templateUrl: './delete-group-child-enrollment-modal.component.html',
    styleUrls: ['./delete-group-child-enrollment-modal.component.scss']
})
export class DeleteGroupChildEnrollmentModalComponent implements OnInit {
    @Input() students!: EnrollmentReportStudent[];
    schoolEnrollmentDetailsNormalized: any[] = [];

    isLoading: boolean = false;
    doneLoading: boolean = false;
    isDeleting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;

    constructor(
        public dialogRef: MatDialogRef<DeleteGroupChildEnrollmentModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private studentSchoolEnrollmentService: StudentSchoolEnrollmentService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;

            if (this.students) {
                this.students.forEach((s) => {
                    s.SCHOOL_ENROLLMENT_DETAILS?.forEach((sed: any) => {
                        this.schoolEnrollmentDetailsNormalized.push(sed);
                    });
                });
            }
        }

        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    delete() {
        if (this.schoolEnrollmentDetailsNormalized && this.schoolEnrollmentDetailsNormalized[0].ID) {
            this.isDeleting = true;
            this.msg = new MsgModel();

            let se: any = this.schoolEnrollmentDetailsNormalized.map((se) => {
                return { ID: se.ID };
            });

            this.studentSchoolEnrollmentService.deleteSchoolEnrollment(se).subscribe({
                next: (res) => {
                    if (res.msg) {
                        if (res.msg.SUCCESS) {
                            this.msg = res.msg;

                            this.msg.MSG += ' (closing in 3 seconds...)';
                            setTimeout(() => {
                                this.dialogRef.close({ deleted: true });
                            }, 3000);
                        } else {
                            this.msg = res.msg;
                        }
                    } else {
                        this.msg = { MSG: 'There was an error deleting these school enrollments', SUCCESS: false };
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.msg = err.msg;
                    } else {
                        this.msg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isDeleting = false;
                }
            });
        } else {
            this.msg = { MSG: 'No school enrollment(s) to delete', SUCCESS: false };
            this.isDeleting = false;
        }
    }

    confirm() {
        this.delete();
    }

    setDoneLoading(doneLoading: boolean) {
        this.doneLoading = doneLoading;
        if (doneLoading) {
        }
    }

    // Dialog function
    closeDialog(closed: boolean) {
        Swal.fire({
            titleText: 'Are you sure you want to continue without deleting?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Go Back',
            icon: 'warning',
            confirmButtonColor: '#3a6b35'
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.dialogRef.close();
            }
        });
    }
}
